/* eslint-disable react-hooks/rules-of-hooks */

// Package Imports
import {useIntl} from 'react-intl'

export const translator = (key: string, extraOptions?: Record<string, any>) => {
  const intl = useIntl()

  return intl.formatMessage({id: key}, extraOptions)
}